import moment from 'moment-timezone'
import {
  DATETIME_FORMAT_SHORT,
  DATETIME_FORMAT_HR_MIN,
  DATETIME_FORMAT_MONTH_DAY
} from '@/constants/datetime.constants'
import { minutesToMilliseconds } from '@/utilities/datetime.helper.js'

export function normalize (val, min, max) {
  if (max - min === 0) return 1
  let normalized = (val - min) / (max - min)
  return normalized
}

export function getStatisticsTimeRangeFormat (timeChoice) {
  switch (timeChoice) {
    case 'PAST_1_HOURS':
      return DATETIME_FORMAT_HR_MIN
    case 'PAST_2_HOURS':
      return DATETIME_FORMAT_HR_MIN
    case 'PAST_4_HOURS':
      return DATETIME_FORMAT_HR_MIN
    case 'PAST_24_HOURS':
      return DATETIME_FORMAT_HR_MIN
    case 'PAST_48_HOURS':
      return DATETIME_FORMAT_HR_MIN
    case 'PAST_72_HOURS':
      return DATETIME_FORMAT_HR_MIN
    case 'PAST_1_WEEK':
      return DATETIME_FORMAT_MONTH_DAY
    case 'PAST_1_MONTH':
      return DATETIME_FORMAT_MONTH_DAY
    default:
      return DATETIME_FORMAT_SHORT
  }
}

export function getStatisticsTooltipTimeRangeFormat (timeChoice, value) {
  let epochMillisec = minutesToMilliseconds(value)
  let label = moment(epochMillisec).format(DATETIME_FORMAT_SHORT)

  switch (timeChoice) {
    case 'PAST_1_HOURS':
      return `1 min @ ${label}`
    case 'PAST_2_HOURS':
      return `2 min @ ${label}`
    case 'PAST_4_HOURS':
      return `5 min @ ${label}`
    case 'PAST_24_HOURS':
      return `30 min @ ${label}`
    case 'PAST_48_HOURS':
      return `1 hr @ ${label}`
    case 'PAST_72_HOURS':
      return `2 hr @ ${label}`
    case 'PAST_1_WEEK':
      return `4 hr @ ${label}`
    case 'PAST_1_MONTH':
      return `1 day @ ${label}`
    default:
      return `30 min @ ${label}`
  }
}



// WEBPACK FOOTER //
// ./src/utilities/statistics.helper.js